import { render } from "./createproduct.vue?vue&type=template&id=04698ded&scoped=true"
import script from "./createproduct.vue?vue&type=script&lang=js"
export * from "./createproduct.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./createproduct.vue?vue&type=style&index=1&id=04698ded&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04698ded"]])

export default __exports__